import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  body: theme => css`
    display: flex;
    flex-direction: row;
    justify-items: flex-start;
    align-items: center;

    span {
      display: flex;
      flex-direction: row;
      justify-items: flex-start;
      align-items: center;
      margin-right: ${theme.spacing.xxs};
    }

    @media (max-width: ${theme.grid.breakpoint.sm}) {
      flex-direction: column;
      justify-items: flex-start;
      align-items: center;
      span {
        display: flex;
        flex-direction: row;
        justify-items: flex-start;
        align-items: center;
      }
    }
  `,

  gmtWrapper: theme => css`
    display: flex;
    flex-direction: column;

    @media (max-width: ${theme.grid.breakpoint.sm}) {
      align-items: center;
    }
  `,

  copyText: theme => css`
    margin-top: ${theme.spacing.xxs};
    color: ${theme.colors.neutral[400]};
    width: 100%;
    z-index: 9;

    @media (max-width: ${theme.grid.breakpoint.sm}) {
      text-align: center;
    }
  `,
})

export { useStyles }
